// src/pages/Informes.jsx
import React, { useState, useEffect } from 'react';
import '../style/Informes.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';

const TELEGRAM_ENDPOINT = 'https://marketbusters.pro/telegram/enviar_telegram.php';
const TELEGRAM_GROUP_ID = '-1002583737824';

const countryEmojis = {
  Chile: '🇨🇱',
  Peru: '🇵🇪',
  Argentina: '🇦🇷',
  Ecuador: '🇪🇨',
  Colombia: '🇨🇴',
};

const fieldEmojis = {
  Proveedor: '🏷️',
  Nombre: '📦',
  Categoría: '📂',
  Total: '📦',
  Ventas: '💰',
};

const Informes = () => {
  const [data, setData] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [filter, setFilter] = useState({});
  const [activeDaysFilter, setActiveDaysFilter] = useState(null);
  const [sortConfig, setSortConfig] = useState(null);
  const [dropdownOptions, setDropdownOptions] = useState({});
  const [openDropdown, setOpenDropdown] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showZeroSales, setShowZeroSales] = useState(false);
  const [showEnviarCol, setShowEnviarCol] = useState(false);

  const sendToTelegram = async (row) => {
    const header = '🚨 Alarma de PRODUCTO WINNER - DROPDROP 🚨';
    const keys = ['Proveedor', 'Nombre', 'Categoría', 'País', 'Total', 'Ventas'];

    const lines = keys.map(key => {
      if (key === 'País') {
        const val = row[key];
        return `🌍 <b>País</b>: ${val} ${countryEmojis[val] || ''}`;
      }
      let val = row[key];
      let label = key;
      if (key === 'Total') label = 'Stock';
      if (key === 'Ventas') {
        label = 'Ventas de los últimos días';
        val = Math.abs(Number(val));
      }
      return `${fieldEmojis[key] || ''} <b>${label}</b>: ${val}`;
    });

    const message = [header, ...lines].join('\n\n');

    try {
      const res = await fetch(TELEGRAM_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          groupId: TELEGRAM_GROUP_ID,
          id: row.ID,
          message
        })
      });
      const js = await res.json();
      alert(js.success || js.ok ? 'Enviado correctamente' :
        js.error || js.description || 'Error al enviar');
    } catch (err) {
      console.error(err);
      alert('Error de red al enviar a Telegram');
    }
  };

  useEffect(() => {
    fetch('https://marketbusters.pro/informes/get_productos.php')
      .then(r => {
        if (!r.ok) throw new Error(`Error HTTP: ${r.status}`);
        return r.json();
      })
      .then(json => {
        if (!Array.isArray(json)) throw new Error('La respuesta no es un array.');
        if (json.length === 0) {
          alert('No se encontraron productos.');
          return;
        }
        setHeaders(Object.keys(json[0]));
        setData(json);

        const opts = {};
        json.forEach(row =>
          Object.entries(row).forEach(([k, v]) => {
            opts[k] = opts[k] || new Set();
            opts[k].add(v);
          })
        );
        setDropdownOptions(
          Object.fromEntries(
            Object.entries(opts).map(([k, s]) => [k, [...s].sort()])
          )
        );
      })
      .catch(err => {
        console.error('Error cargando productos:', err);
        alert('Error al cargar productos: ' + err.message);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    const outside = (e) => {
      if (!e.target.closest('.dropdown-container')) setOpenDropdown(null);
    };
    if (openDropdown !== null) document.addEventListener('click', outside);
    return () => document.removeEventListener('click', outside);
  }, [openDropdown]);

  const handleFilter = (col, val) => {
    setFilter(f => ({ ...f, [col]: val }));
    setOpenDropdown(null);
    setActiveDaysFilter(null);
  };
  const toggleDropdown = col => setOpenDropdown(o => (o === col ? null : col));
  const handleSort = col => {
    let dir = 'ascending';
    if (sortConfig?.key === col && sortConfig.direction === 'ascending') dir = 'descending';
    setSortConfig({ key: col, direction: dir });
  };

  let filtered = data.filter(r => showZeroSales || Number(r.Ventas) !== 0);
  if (activeDaysFilter) {
    filtered = filtered.filter(
      r =>
        r.País === activeDaysFilter.country &&
        Number(r.Días) > activeDaysFilter.threshold
    );
  } else {
    filtered = filtered.filter(r =>
      Object.entries(filter).every(
        ([k, v]) => !v || r[k]?.toString().toLowerCase().includes(v.toLowerCase())
      )
    );
  }

  const sorted = [...filtered].sort((a, b) => {
    if (!sortConfig) return 0;
    const { key, direction } = sortConfig;
    if (a[key] === b[key]) return 0;
    return (a[key] > b[key] ? 1 : -1) * (direction === 'ascending' ? 1 : -1);
  });

  const countries = [...new Set(data.map(r => r.País))];
  const cntProd = Object.fromEntries(
    countries.map(c => [
      c,
      data.filter(r => r.País === c && Number(r.Ventas) !== 0).length
    ])
  );
  const cnt5 = Object.fromEntries(
    countries.map(c => [
      c,
      data.filter(r => r.País === c && Number(r.Días) > 5).length
    ])
  );
  const cnt7 = Object.fromEntries(
    countries.map(c => [
      c,
      data.filter(r => r.País === c && Number(r.Días) > 7).length
    ])
  );

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner" />
        <p>Cargando datos...</p>
      </div>
    );
  }

  return (
    <div className="informes-container">
      <table className="informes-table">
        <thead>
          <tr>
            <th colSpan={headers.length + (showEnviarCol ? 1 : 0)}>
              <div className="country-box-wrapper">
                {countries.map(c => (
                  <div className="country-box" key={c}>
                    <span className="country-emoji">{countryEmojis[c] || '🏳️'}</span>{' '}
                    {c}: Productos: {cntProd[c]}
                  </div>
                ))}
              </div>
            </th>
          </tr>

          <tr>
            <th colSpan={headers.length + (showEnviarCol ? 1 : 0)}>
              <div className="country-box-wrapper" style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '10px' }}>
                {countries.flatMap(c => {
                  const flag = countryEmojis[c] || '🏳️';
                  return [
                    <div
                      className="country-box"
                      key={`${c}-5`}
                      onClick={() => setActiveDaysFilter(p => p?.country === c && p.threshold === 5 ? null : { country: c, threshold: 5 })}
                      style={{ cursor: 'pointer', padding: '4px 8px' }}
                    >
                      {flag} {c}: Días&gt;5: {cnt5[c]}
                    </div>,
                    <div
                      className="country-box"
                      key={`${c}-7`}
                      onClick={() => setActiveDaysFilter(p => p?.country === c && p.threshold === 7 ? null : { country: c, threshold: 7 })}
                      style={{ cursor: 'pointer', padding: '4px 8px' }}
                    >
                      {flag} {c}: Días&gt;7: {cnt7[c]}
                    </div>,
                  ];
                })}
                <div
                  className="country-box"
                  onClick={() => setShowEnviarCol(s => !s)}
                  style={{
                    backgroundColor: '#00AAFF',
                    color: '#FFF',
                    border: 'none',
                    cursor: 'pointer',
                  }}
                >
                  Telegram
                </div>
              </div>
            </th>
          </tr>

          <tr>
            {headers.map((h, idx) => {
              const idxP = headers.indexOf('País');
              const idxD = headers.indexOf('Días');
              const showFilterIcon =
                h !== 'ID' &&
                !(idxP !== -1 && idxD !== -1 && idx > idxP && idx < idxD) &&
                dropdownOptions[h];

              return (
                <th key={h}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <span onClick={() => handleSort(h)} style={{ cursor: 'pointer' }}>
                      {h}
                      {sortConfig?.key === h
                        ? sortConfig.direction === 'ascending'
                          ? ' 🔼'
                          : ' 🔽'
                        : ''}
                    </span>
                    {showFilterIcon && (
                      <div className="dropdown-container" style={{ position: 'relative' }}>
                        <FontAwesomeIcon
                          icon={faFilter}
                          onClick={() => toggleDropdown(h)}
                          style={{ cursor: 'pointer', marginLeft: '5px' }}
                        />
                        <ul className={`dropdown-menu ${openDropdown === h ? 'show' : ''}`} style={{ position: 'absolute', top: '100%', left: 0 }}>
                          <li onClick={() => handleFilter(h, '')}>Todos</li>
                          {dropdownOptions[h].map((opt, i) => (
                            <li key={i} onClick={() => handleFilter(h, opt)}>
                              {opt}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                </th>
              );
            })}
            {showEnviarCol && <th>Enviar</th>}
          </tr>

          <tr className="summary-row">
            {headers.map((h, idx) => {
              if (h === 'ID' || h === 'Días' || h === '%') return <td key={h} />;
              const sum = sorted.reduce((acc, row) => {
                const n = Number(row[h]);
                if (isNaN(n)) return acc;
                if (idx === 15) return acc + n;
                return n < 0 ? acc + n : acc;
              }, 0);
              return (
                <td key={h} style={{ color: 'orange' }}>
                  {sum !== 0 ? sum.toLocaleString() : ''}
                </td>
              );
            })}
            {showEnviarCol && <td />}
          </tr>
        </thead>

        <tbody>
          {sorted.map((row, ri) => (
            <tr key={ri}>
              {headers.map((h, ci) => {
                const val = row[h];
                const neg = typeof val === 'number' && val < 0;
                return (
                  <td key={ci} style={neg ? { color: '#00a67d' } : undefined}>
                    {val}
                  </td>
                );
              })}
              {showEnviarCol && (
                <td>
                  <button
                    onClick={() => sendToTelegram(row)}
                    style={{
                      backgroundColor: '#00AAFF',
                      color: '#FFF',
                      border: 'none',
                      borderRadius: '4px',
                      padding: '4px 8px',
                      cursor: 'pointer',
                    }}
                  >
                    Enviar
                  </button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>

      {!showZeroSales && (
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <button onClick={() => setShowZeroSales(true)}>Cargar productos Ventas 0</button>
        </div>
      )}
    </div>
  );
};

export default Informes;
